import React from 'react';
import _ from 'lodash';
import M from 'materialize-css';
import { Redirect, Link } from 'react-router-dom';

import NavBarLateral from '../NavBarLateral/index';
//import './css/styles.css';

class AdminPublicaciones extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            publicaciones: [],
            isLogged: this.props.auth,
        };
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        M.AutoInit();
        fetch('/api/uip/publicaciones', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => this.setState({publicaciones: response}))
            .catch(err => console.log(err))
    }

    render() {

        const objetosPub = _.map(this.state.publicaciones, (publicacion, i) => {
            
            return (
                <CardAdmin
                    titulo={publicacion.titulo}
                    frase={publicacion.frase}
                    index={publicacion.index}
                    id={publicacion._id}
                    key={i} />
            );
        })

        if(this.state.isLogged === true){
            return (
                <div>
                    <NavBarLateral 
                        isLogged={this.state.isLogged}/>
                    <div className={`pad`}>
                        <div className={`row`}>
                            <NavTitulo 
                                cantidad={this.state.publicaciones.length}/>
                        </div>
                        <div className={`row`}>
                            {objetosPub}
                        </div>
                    </div>
                </div>

            );
        }
        else {
            return <Redirect to="/administrador/login"/>
        }
    }
}

class CardAdmin extends React.Component {

    render() {
        return (
            <div className="col s12 m4">
                <div className={`row`}>
                    <div className={`col s12 m12`}>
                        <div className={`card hoverable`}>
                            <div className="card-image">
                                <img src={this.props.index} className={`border-img`} />
                            </div>
                            <div className="card-content">
                                <span className="card-title custom-fontAdminEspTitle">{this.props.titulo}</span>
                                <p className={`custom-fontAdminEspText`}>{this.props.frase}</p>
                            </div>
                            <div className="card-action">
                                <div className={`row valign-wrapper`}>
                                    <div className={`col s12 m6 left-align`}>
                                        <span>Editar</span>
                                    </div>
                                    <div className={`col s12 m6 right-align`}>
                                        <Link to={{
                                            pathname: '/administrador/publicaciones/actualizar',
                                            state: {
                                                id: this.props.id
                                            }
                                        }}>
                                            <a className="waves-effect waves-light btn light-blue btn-small">
                                                <i className="material-icons right">send</i>
                                                ir
                                            </a>
                                        </Link>
                                    </div>
                                </div>
                                {this.props.listasw}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class NavTitulo extends React.Component{
    render(){
        return(
            <div className="navbar-fixed">
                <nav className="light-blue">
                    <div className="nav-wrapper">
                        <a className="brand-logo margin-titulo-especiales">
                            Publicaciones
                            <span 
                                className="new badge red lighten-1 margin-badge-nav"
                                data-badge-caption="publicaciones">
                                {this.props.cantidad}
                            </span>
                        </a>
                    </div>
                </nav>
            </div>
         
        );
    }
}

export default AdminPublicaciones;